import AuthGuard from '@/guard/auth'
import Navbar from '@/components/menu/Navbar'
import NetworkPage from '@/components/pages/NetworkPage'
import IamGuard from '@/guard/iam'

function NetworkIndex() {
	return (
		<AuthGuard>
            <IamGuard page='network'>
			<div className='relative min-h-screen flex flex-col'>
				<Navbar></Navbar>
				<NetworkPage></NetworkPage>
			</div>
            </IamGuard>
		</AuthGuard>
	)
}

export default NetworkIndex
